module.exports = __webpack_public_path__ + "img/logo-two-lines_simple.d86688a6.svg";